import React, { useState } from "react";
import { Button, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getRequirementDoc } from "../../redux/seleccionContratacion/RequirementsMonitor/actions";
const LinkDescargaRequirement = (props) => {
  //*states
  const [loader, setLoader] = useState(false);
  //*variables
  const dispatch = useDispatch();
  return (
    <OverlayTrigger
      placement="auto"
      overlay={<Tooltip {...props}>Descargar requisición</Tooltip>}
    >
      <Button
        size="sm"
        className="text-primary rounded"
        variant="link"
        type="button"
        onClick={() => dispatch(getRequirementDoc(props.id, setLoader))}
        disabled={loader}
      >
        {loader ? (
          <Spinner
            className="ml-2"
            animation="border"
            variant="primary"
            size="sm"
          />
        ) : (
          <i className="material-icons">download</i>
        )}
      </Button>
    </OverlayTrigger>
  );
};

export default LinkDescargaRequirement;
